import axios from 'axios';
import { URLS } from '../config';
import { AppDispatch } from '../store';
import { RootState } from '../store';

interface RegisterData {
  username: string;
  phone_number: string;
  first_name: string;
  last_name: string;
  address: string;
  city: string;
}

interface RegisterResponse {
  success: boolean;
  message: string;
  fieldErrors?: Record<string, string>;
}

function isEmpty(value: string | undefined | null) {
  return !value || value.trim().length === 0;
}

export const registerHandler = async (
  {
    username,
    phone_number,
    first_name,
    last_name,
    address,
    city,
  }: RegisterData,
  dispatch: AppDispatch,
  getState: () => RootState
): Promise<RegisterResponse> => {
  // بررسی ورودی‌ها
  if (
    isEmpty(username) ||
    isEmpty(phone_number) ||
    isEmpty(first_name) ||
    isEmpty(last_name) ||
    isEmpty(address) ||
    isEmpty(city)
  ) {
    return {
      success: false,
      message: 'تمام فیلدها باید به درستی پر شوند.',
    };
  }

  const device_uuid = getState().device.uuid;

  try {
    const response = await axios.post(
      URLS.REGISTER,
      {
        username,
        phone_number,
        first_name,
        last_name,
        address,
        device_uuid,
        city,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    // پاسخ 200 و موفقیت
    if (response.status === 201) {
      const data = response.data;

      if (data.username) {

        return {
          success: true,
          message: 'ثبت‌نام با موفقیت انجام شد.',
        };
      } else {
        // خطاهای غیرمربوط
        if (Array.isArray(data.non_field_errors) && data.non_field_errors.length > 0) {
          return {
            success: false,
            message: data.non_field_errors[0],
          };
        }

        return {
          success: false,
          message: data.message || 'خطا در ثبت‌نام. لطفاً دوباره تلاش کنید.',
        };
      }
    }

    // وضعیت 400
    if (response.status === 400) {
      return {
        success: false,
        message: response.data.message || 'اطلاعات وارد شده نادرست است.',
      };
    }

    // سایر پاسخ‌ها
    return {
      success: false,
      message: response.data.message || 'خطایی رخ داد. لطفاً دوباره تلاش کنید.',
    };
  } catch (error: unknown) {
    console.error(error);
  
    if (
      typeof error === 'object' &&
      error !== null &&
      'response' in error &&
      typeof (error as any).response === 'object' &&
      (error as any).response !== null &&
      'data' in (error as any).response
    ) {
      const errResp = (error as any).response.data;
  
      // استخراج خطاهای فیلدها
      const fieldErrors: Record<string, string> = {};
      Object.entries(errResp).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          fieldErrors[key] = value[0]; // فقط اولین پیام برای هر فیلد
        }
      });
  
      // اولویت نمایش پیام کلی برای non_field_errors
      if (fieldErrors.non_field_errors) {
        return {
          success: false,
          message: fieldErrors.non_field_errors,
          fieldErrors,
        };
      }
  
      return {
        success: false,
        message: 'لطفاً خطاهای فرم را بررسی کنید.',
        fieldErrors,
      };
    }
  
    return {
      success: false,
      message: 'مشکلی در اتصال به سرور پیش آمد. لطفاً بعداً دوباره تلاش کنید.',
    };
  }
};
